// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-title {
    font-family: Arial, sans-serif;
    font-size: 11pt;
    font-weight: bold;
}

.form-subtitle {
    font-family: Arial, sans-serif;
    font-size: 8pt;
}

.form-section-title {
    font-family: Arial, sans-serif;
    font-size: 8pt;
    font-weight: bold;
}

.form-text {
    font-family: Arial, sans-serif;
    font-size: 6.5pt;
}

.form-text-small {
    font-family: Arial, sans-serif;
    font-size: 9pt;
}

.form-container {
    width: 210mm;
    min-height: 297mm;
    background: white;
    padding: 20mm;
    margin: 0 auto;
}

@media print {
    @page {
        size: A4;
        margin: 20mm;
    }

    body {
        margin: 0;
        padding: 0;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}

.print-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 10pt;
}

table {
    font-family: Arial, sans-serif;
    font-size: 10pt;
}

/* Novo estilo para células de tabela */
.table-cell {
    padding: 0.5px 1px !important;
    height: 14px;
    line-height: 1;
}

.table-header {
    padding: 0.5px 1px !important;
    height: 16px;
    line-height: 1;
    font-weight: normal;
}

.print-container {
    display: none; /* Esconde na tela mas permite impressão */
}

.print-wrapper {
    position: relative;
}

.print-content {
    background: white;
    width: 210mm;
    min-height: 297mm;
    margin: 0 auto;
    padding: 20mm;
}

@media print {
    @page {
        size: A4;
        margin: 20mm;
    }

    body {
        margin: 0;
        padding: 0;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .fixed {
        display: none !important;
    }
}

.print-only {
    display: none;
} `, "",{"version":3,"sources":["webpack://./src/Components/print/style.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI;QACI,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,4CAA4C;QAC5C,oCAAoC;IACxC;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA,uCAAuC;AACvC;IACI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa,EAAE,0CAA0C;AAC7D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;QACI,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".form-title {\n    font-family: Arial, sans-serif;\n    font-size: 11pt;\n    font-weight: bold;\n}\n\n.form-subtitle {\n    font-family: Arial, sans-serif;\n    font-size: 8pt;\n}\n\n.form-section-title {\n    font-family: Arial, sans-serif;\n    font-size: 8pt;\n    font-weight: bold;\n}\n\n.form-text {\n    font-family: Arial, sans-serif;\n    font-size: 6.5pt;\n}\n\n.form-text-small {\n    font-family: Arial, sans-serif;\n    font-size: 9pt;\n}\n\n.form-container {\n    width: 210mm;\n    min-height: 297mm;\n    background: white;\n    padding: 20mm;\n    margin: 0 auto;\n}\n\n@media print {\n    @page {\n        size: A4;\n        margin: 20mm;\n    }\n\n    body {\n        margin: 0;\n        padding: 0;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n}\n\n.print-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    font-size: 10pt;\n}\n\ntable {\n    font-family: Arial, sans-serif;\n    font-size: 10pt;\n}\n\n/* Novo estilo para células de tabela */\n.table-cell {\n    padding: 0.5px 1px !important;\n    height: 14px;\n    line-height: 1;\n}\n\n.table-header {\n    padding: 0.5px 1px !important;\n    height: 16px;\n    line-height: 1;\n    font-weight: normal;\n}\n\n.print-container {\n    display: none; /* Esconde na tela mas permite impressão */\n}\n\n.print-wrapper {\n    position: relative;\n}\n\n.print-content {\n    background: white;\n    width: 210mm;\n    min-height: 297mm;\n    margin: 0 auto;\n    padding: 20mm;\n}\n\n@media print {\n    @page {\n        size: A4;\n        margin: 20mm;\n    }\n\n    body {\n        margin: 0;\n        padding: 0;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    .fixed {\n        display: none !important;\n    }\n}\n\n.print-only {\n    display: none;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
